import { Container } from 'reactstrap';
import VideoPage from '../components/VideoPage';
import React from 'react';



const MoreInfoPage = () => {
    return (
        <Container>
            <VideoPage/>            
        </Container>
    );  
       
};

export default MoreInfoPage;